import { render, staticRenderFns } from "./ViewCVS.vue?vue&type=template&id=94bb48f4&scoped=true&"
import script from "./ViewCVS.vue?vue&type=script&lang=js&"
export * from "./ViewCVS.vue?vue&type=script&lang=js&"
import style0 from "./ViewCVS.vue?vue&type=style&index=0&id=94bb48f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bb48f4",
  null
  
)

export default component.exports